/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

let a = '';
export const environment = {
  production: false,
  name: 'local',
  reports_url: 'https://reports.staging.nuvertos.com/',
  notification_url: 'https://notification.staging.nuvertos.com/',
  hospital_url: 'https://hospital.staging.nuvertos.com/',
  print_url: 'https://print.staging.nuvertos.com/',
  auth_uri: a + 'https://directory.staging.nuvertos.com/',
  patient_uri: a + 'https://patient.staging.nuvertos.com/',
  filemgr_url: a + 'https://files.staging.nuvertos.com/',
  billing_url: a + 'https://billing.staging.nuvertos.com/',  
  prescription_url: a + 'https://prescription.staging.nuvertos.com/',
  appointment_url: a + 'https://appointment.staging.nuvertos.com/',
  pharmacy_url: a + 'https://pharmacy.staging.nuvertos.com/',
  radio_url: a + 'https://radiology.staging.nuvertos.com/',
  lab_url: a + 'https://lims.staging.nuvertos.com/',
  tpa_url: a + 'https://tpa.staging.nuvertos.com/',
  form_url: a + 'https://form.staging.nuvertos.com/',
};
